module.exports = __webpack_public_path__ + "static/media/iso_main_text_mobile.47693a2b.png";